import React from 'react';
import { ShoppingCartItemDetailsProps } from '../interfaces';
import MaterialSelector from '../materialSelector';
import SizeSelector from '../sizeSelector';
import ShoppingCartQuantityControls from './ShoppingCartQuantityControls';

const ShoppingCartItemDetails: React.FC<ShoppingCartItemDetailsProps> = ({
  item,
  itemPrice,
  materialDataLoading,
  selectedMaterial,
  selectedSize,
  stockQuantity,
  validationMessage,
  onDecrementQuantity,
  onIncrementQuantity,
}) => {
  const incrementDisabled = materialDataLoading
    || (typeof stockQuantity === 'number' ? item.quantity >= stockQuantity : false);

  return (
    <div className="custom-card-body">
      <div className="cart-item-meta">
        <div className="cart-item-title-row">
          <h3 className="title">{item.product.title}</h3>
        </div>
        <p>Type: {item.product.productType?.name}</p>

        <div className="size-material-dropdowns">
          <div className="material-dropdown">
            <MaterialSelector
              value={selectedMaterial}
              materials={item.product.materialPrices}
              itemId={item.id}
              productId={item.product.id}
              dataSource="cart"
            />
          </div>
          <div className="size-dropdown">
            <SizeSelector
              itemId={item.id}
              selectedSize={selectedSize}
              dataSource="cart"
            />
          </div>
        </div>
        <p>Price: {materialDataLoading ? 'Loading...' : `$${itemPrice.toFixed(2)}`}</p>
        <p>In stock: {materialDataLoading ? 'Loading...' : typeof stockQuantity === 'number' ? stockQuantity : '...'}</p>
        {validationMessage && (
          <p className="cart-item-warning">{validationMessage}</p>
        )}
        <ShoppingCartQuantityControls
          disabled={materialDataLoading}
          incrementDisabled={incrementDisabled}
          productTitle={item.product.title}
          quantity={item.quantity}
          onDecrement={onDecrementQuantity}
          onIncrement={onIncrementQuantity}
        />
      </div>
    </div>
  );
};

export default React.memo(ShoppingCartItemDetails);
